import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import 'primereact/resources/themes/nova/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import {
    getStaticWeights,
    getMutualValue,
    encodeMatrixTable,
    decodeMatrixTable,
    getAutoQualitativeMatrix,
} from '../utils/qualitativeMatrixUtils';


class PerformanceMatrix extends Component {

    constructor(props) {
        super(props);

        this.matrixId = this.props.matrixId;

        this.state = {
            matrixValues: [],
            matrixName: null,
            isLoading: true,
            errors: null
        };

        this.weightEditor = this.weightEditor.bind(this);
        this.generateAutoQualitativeMatrix = this.generateAutoQualitativeMatrix.bind(this);
    }

    componentDidMount() {
        this.fetchData();
    }

    //Get matrix values
    fetchData() {
        //Values from props
        var matrixData = this.props.matrix;

        this.setState({
            matrixValues: encodeMatrixTable(matrixData),
            matrixName: this.props.name,
            isLoading: false,
        })
    }

    onEditorValueChange(props, value) {
        let updatedValues = [...props.value];
        updatedValues[props.rowIndex][props.field] = value;

        value = getMutualValue(value);
        updatedValues[props.field][props.rowIndex] = value;

        this.setState({ matrixValues: updatedValues });

        setTimeout(function () {
            if (document.querySelector('.p-datatable') !== null) {
                document.querySelector('.p-datatable').click();
            }
        }, 300);
    }

    weightEditor(props) {
        var dropdown;
        let weights = [];
            weights = getStaticWeights();
            dropdown = <Dropdown value={props.value[props.rowIndex] ? props.value[props.rowIndex].weight : undefined} options={weights}
                onChange={(e) => this.onEditorValueChange(props, e.value)} style={{ width: '100%', position: 'relative' }}
                placeholder="Select a value" />
        return (dropdown);
    }

    /**
     * Generazione di una matrice coerente
     */
    generateAutoQualitativeMatrix(){
        this.setState({ matrixValues: getAutoQualitativeMatrix(this.state.matrixValues) });
    }

    render() {
        const { matrixValues, matrixName } = this.state;

        if(matrixValues){
            let dynamicColumns = matrixValues.map((col, i) => {
                if (col.field !== 'alternatives') {
                    return <Column key={col.field} field={col.field} header={col.header} editor={(e) => this.weightEditor({...e, value: e.props.value})} />;
                }
                else{
                    return null;
                }
            });

            var matrixToSend = decodeMatrixTable(matrixValues);
            var inputMatrixToSend = this.matrixId;
            matrixToSend['name'] = matrixName
            return (
                <div>
                    <DataTable value={matrixValues} editMode="cell">
                        <Column field="alternatives" />
                        {dynamicColumns}
                    </DataTable>
                    <div style={{ display: "flex" }}>
                        <Button label="Generate consistent matrix" onClick={this.generateAutoQualitativeMatrix} style={{ marginTop: 20, marginLeft: "auto" }} />
                    </div>
                    <input name={inputMatrixToSend} type="hidden" value={JSON.stringify(matrixToSend)} />
                </div>
            );
        }
    }
}

export default PerformanceMatrix;
